<template>
    <LayoutSub className="business_unit">
        <SubSection classList="pb-0">
            <h1>쉽고 편리한 O2O <br class="mo-only" />결제 서비스를 제공하는 <strong class="c-red">PG사업본부</strong></h1>
            <p>
                가맹점과 소비자의 더욱 편리한 온·오프라인 결제서비스 제공을 위해 노력합니다. <br />
                가맹점의 원활한 상품 판매와 소비자의 더 나은 결제 경험을 위해 PG사업본부는 가맹점과 소비자 사이에서 온·오프라인 결제서비스와 정산업무
                등 최상의 PG솔루션인 'EasyPay'를 제공하고 있습니다.<br />
                <br />
                지속 성장하는 온·오프라인 결제시장에서 신규 시장을 개척하고 대기업부터 스타트업까지 다양한 분야, 가맹점들의 결제 파트너로서 <br class="pc-only" />
                가맹점 모집과 신규 비즈니스 모델을 개발하여 시장을 선도할 도적적이고 열정적인 인재를 기다립니다.
            </p>
            <img src="@/assets/pg_image01.png" alt="" />
        </SubSection>
    </LayoutSub>
</template>
<script>
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubSection,
    },
};
</script>
